import { Link, useLocation, useParams } from "react-router-dom";
import { Factory, FileText, Package, ShoppingCart, User, Truck } from "lucide-react";
import { cn } from "@/lib/utils";

const tabs = [
  {
    id: "dados",
    label: "Dados",
    shortLabel: "Dados",
    icon: User,
    path: (clientId: string) => `/dashboard/clients/${clientId}`,
  },
  {
    id: "produtos",
    label: "Produtos",
    shortLabel: "Prod.",
    icon: Package,
    path: (clientId: string) => `/dashboard/clients/${clientId}/products`,
  },
  {
    id: "encomendas",
    label: "Encomendas",
    shortLabel: "Enc.",
    icon: ShoppingCart,
    path: (clientId: string) => `/dashboard/clients/${clientId}/orders`,
  },
  {
    id: "ordens-fabrico",
    label: "Ordens de Fabrico",
    shortLabel: "Fabrico",
    icon: Factory,
    path: (clientId: string) => `/dashboard/clients/${clientId}/factory-orders`,
  },
  // A aba "Produção" saiu daqui: a rota `/clients/:id/production` já não
  // existe (a antiga `production-detail-page` foi absorvida pela aba Produção
  // da Ficha Técnica, dentro de Ordens de Fabrico). A aba ficou a apontar para
  // o vazio e levava a um ecrã em branco.
  {
    id: "expedicao",
    label: "Expedição",
    shortLabel: "Exp.",
    icon: Truck,
    path: (clientId: string) => `/dashboard/clients/${clientId}/expedition`,
  },
  {
    id: "faturas",
    label: "Faturas",
    shortLabel: "Faturas",
    icon: FileText,
    path: (clientId: string) => `/dashboard/clients/${clientId}/invoices`,
  },
];

export const ClientNavbar = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const location = useLocation();

  if (!clientId) return null;

  const isActive = (path: string) => {
    if (path === `/dashboard/clients/${clientId}`) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    // Sem borda nem cor próprias — quem a envolve (a moldura da app) já as dá.
    <div className="w-full">
      <div
        className={cn(
          "flex items-center",
          // On mobile: horizontal scrolling for overflow, stack icons compactly. On desktop: tabs are clearly visible and spaced
          "overflow-x-auto",
          "px-2 sm:px-6 gap-2 sm:gap-3"
        )}
        style={{
          WebkitOverflowScrolling: "touch",
        }}
      >
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const path = tab.path(clientId);
          const active = isActive(path);

          return (
            <Link key={tab.id} to={path} className="shrink-0">
              <button
                className={cn(
                  "flex items-center gap-2 border-b-2 border-transparent font-medium transition-colors select-none bg-transparent",
                  "px-3 sm:px-4 py-3",
                  "text-xs sm:text-sm",
                  active
                    ? "border-primary text-primary"
                    : "text-muted-foreground hover:text-foreground hover:border-muted"
                )}
                tabIndex={0}
                style={{ whiteSpace: "nowrap", background: "none" }}
              >
                <Icon className="h-4 w-4" />
                {/* Mobile: show short label, Desktop: show full label */}
                <span className="sm:hidden">{tab.shortLabel}</span>
                <span className="hidden sm:inline">{tab.label}</span>
              </button>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
